import './instrument.js' // MUST be before other React imports
import React from 'react'
import * as Sentry from "@sentry/react"
import { ClerkProvider } from "@clerk/react"
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'

const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <Sentry.ErrorBoundary fallback={<p>Something went wrong. Please refresh the page.</p>} showDialog>
            {PUBLISHABLE_KEY ? (
                <ClerkProvider publishableKey={PUBLISHABLE_KEY} afterSignOutUrl="/">
                    <App />
                </ClerkProvider>
            ) : (
                <App />
            )}
        </Sentry.ErrorBoundary>
    </React.StrictMode>,
)
